var _g, _defs;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  let title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    preserveAspectRatio: "none",
    overflow: "visible",
    style: {
      display: "block"
    },
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "calendar/Icon-Calendar",
    clipPath: "url(#clip0_0_23)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector (Stroke)",
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M7.47694 1.84619C7.98674 1.84619 8.40002 2.25947 8.40002 2.76927V3.50773H15.6V2.86159C15.6 2.35178 16.0133 1.93851 16.5231 1.93851C17.0329 1.93851 17.4462 2.35178 17.4462 2.86159V3.50773H18.4615C20.5406 3.50773 22.1539 5.12101 22.1539 7.20004V18.5539C22.1539 20.6329 20.5406 22.2462 18.4615 22.2462H5.53847C3.45944 22.2462 1.84616 20.6329 1.84616 18.5539V7.20004C1.84616 5.12101 3.45944 3.50773 5.53847 3.50773H6.55386V2.76927C6.55386 2.25947 6.96714 1.84619 7.47694 1.84619ZM6.55386 5.35388H5.53847C4.47904 5.35388 3.69231 6.14061 3.69231 7.20004V9.04619H20.3077V7.20004C20.3077 6.14061 19.521 5.35388 18.4615 5.35388H17.4462V6.09235C17.4462 6.60216 17.0329 7.01543 16.5231 7.01543C16.0133 7.01543 15.6 6.60216 15.6 6.09235V5.35388H8.40002V6.00004C8.40002 6.50984 7.98674 6.92311 7.47694 6.92311C6.96714 6.92311 6.55386 6.50984 6.55386 6.00004V5.35388ZM20.3077 10.8923H3.69231V18.5539C3.69231 19.6133 4.47904 20.4 5.53847 20.4H18.4615C19.521 20.4 20.3077 19.6133 20.3077 18.5539V10.8923Z",
    fill: "#373737"
  }), /*#__PURE__*/React.createElement("g", {
    id: "Caminho 47731"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_0_23"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 24,
    height: 24,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.89ec1cd9d58807cb49325c037d57c5af.svg";
export { ForwardRef as ReactComponent };